import { Button } from '@iwoca/orion';
import { Trans } from '@lingui/react/macro';
import { useAmplitude } from 'hooks/useAmplitude';
import { AMPLITUDE_EVENTS } from 'utils/tracking/tracking.events';
import { useContinueRedirect } from '../useContinueRedrect.hook';

type TProps = {
  stateKey: string;
  applicationId: string;
};

export const ContinueApplicationButton = ({
  stateKey,
  applicationId,
}: TProps) => {
  const { trackEvent } = useAmplitude();
  const { handleRedirect, getRedirectUrl, redirectionId } =
    useContinueRedirect();

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();

    trackEvent(AMPLITUDE_EVENTS.dashboardCTAClicked, { Status: 'Open' });
    trackEvent(AMPLITUDE_EVENTS.signupCTAClicked, {
      'CTA location': 'Application table',
      'CTA text': 'Continue app',
      'CTA URL': getRedirectUrl(applicationId),
    });

    handleRedirect(stateKey, applicationId);
  };

  return (
    <Button
      loading={redirectionId === stateKey}
      size="small"
      onClick={handleClick}
    >
      <Trans>Continue app</Trans>
    </Button>
  );
};
